import { createApp } from 'vue'
import App from './app.vue'
import store from './store'

import OpenLayersMap from 'vue3-openlayers'
import 'vue3-openlayers/dist/vue3-openlayers.css'
import './scss/index.scss'

htmlReady(() => {
	const app = createApp(App)

	app.use(OpenLayersMap)
	app.use(store)

	app.mount('#knd-app')
})

// wait till everything is rendered 
function htmlReady(cb){
	// in case the document is already rendered
	if (document.readyState!='loading'){
		cb();
	}

	// modern browsers
	else if (document.addEventListener){ 
		document.addEventListener('DOMContentLoaded', cb);
	}
	// IE <= 8
	else document.attachEvent('onreadystatechange',() => {
		if (document.readyState=='complete') cb();
	});
}